import { render, staticRenderFns, recyclableRender, components } from "./maps.vue?vue&type=template&id=36df0b66&scoped=true&"
var renderjs
import script from "./maps.vue?vue&type=script&lang=js&"
export * from "./maps.vue?vue&type=script&lang=js&"
import style0 from "./maps.vue?vue&type=style&index=0&id=36df0b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df0b66",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/maps/maps.vue"
export default component.exports